import { LINK_PRE_PATH } from 'constants/solution';

export const urlPre = 'http://sdk-source.xylink.com/website/assets/product/hcvp/';

export const fusions = [
  {
    title: '功能融合',
    desc: '通过超融合音视频中台，打通传统视频会议、视频监控、直播、录\n播、数据共享、语音融合互通等多种功能。为各行业提供高清流\n畅、便捷易用、功能丰富、安全稳定的可视化体验。',
    mDesc: '通过超融合音视频中台，打通传统视频会议、视\n频监控、直播、录播、数据共享、语音融合互通\n等多种功能。为各行业提供高清流畅、便捷易\n用、功能丰富、安全稳定的可视化体验。',
    icon: urlPre + '%E7%BC%96%E7%BB%84.png',
    mIcon: urlPre + 'mobile/%E5%8A%9F%E8%83%BD%E5%A4%87%E4%BB%BD.png',
  },
  {
    title: '软硬件融合',
    desc: '全面支持内网、互联网环境下硬件终端和软件客户端的融合。实现\n随时、随地轻松接入，满足室内、户外全场景沟通需求，让协作更\n高效。',
    mDesc: '全面支持内网、互联网环境下硬件终端和软件客\n户端的融合。实现随时、随地轻松接入，满足室\n内、户外全场景沟通需求，让协作更高效。',
    icon: urlPre + '2.png',
    mIcon: urlPre + 'mobile/%E8%BD%AF%E7%A1%AC%E4%BB%B6%E5%A4%87%E4%BB%BD.png',
  },
  {
    title: '信创融合',
    desc: '掌握自主核心技术，兼容各类国产CPU、操作系统和数据库。通过\n全面适配信创解决方案，保障管理自主可控、应用安全可靠。',
    mDesc: '掌握自主核心技术，兼容各类国产CPU、操作系\n统和数据库。通过全面适配信创解决方案，保障\n管理自主可控、应用安全可靠。',
    icon: urlPre + 'tos_c34183cf484145a978039dcfce98b311%E5%A4%87%E4%BB%BD.png',
    mIcon: urlPre + 'mobile/%E4%BF%A1%E5%88%9B%E5%A4%87%E4%BB%BD.png',
  },
  {
    title: '多品牌互联融合',
    desc: '采用AVC+SVC双引擎，可兼容多种不同品牌视频会议系统。在保\n障超高清云视频应用的同时充分利旧，有效保护组织既有投资，实\n现资源有效整合。',
    mDesc: '采用AVC+SVC双引擎，可兼容多种不同品牌视\n频会议系统。在保障超高清云视频应用的同时充\n分利旧，有效保护组织既有投资，实现资源有效\n整合。',
    icon: urlPre + '%E5%A4%9A%E5%93%81%E7%89%8C%E5%A4%87%E4%BB%BD.png',
    mIcon: urlPre + 'mobile/%E5%A4%9A%E5%93%81%E7%89%8C%E5%A4%87%E4%BB%BD.png',
  },
  {
    title: '业务系统融合',
    desc: '全面开放平台能力，以轻代码方式，深度嵌入业务流程，让各行业\n快速具备视频会议能力。打通多场景、多业务线的视频应用需求，\n构建可统一调度的综合性业务平台。',
    mDesc: '全面开放平台能力，以轻代码方式，深度嵌入业\n务流程，让各行业快速具备视频会议能力。打通\n多场景、多业务线的视频应用需求，构建可统一\n调度的综合性业务平台。',
    icon: urlPre + '5%E5%A4%87%E4%BB%BD.png',
    mIcon: urlPre + 'mobile/%E4%B8%9A%E5%8A%A1%E7%B3%BB%E7%BB%9F%E5%A4%87%E4%BB%BD.png',
  },
];

export const arrowIcon = [
  urlPre + '%E6%97%A0%E6%89%80%E4%B8%8D%E8%9E%8D-bg.png',
  urlPre + '%E4%B8%80%E5%BA%94%E4%BF%B1%E5%85%A8-bg1.png',
  urlPre + '%E4%B8%80%E5%BA%94%E4%BF%B1%E5%85%A8-bg2.png',
  urlPre + '%E6%A0%87%E9%A2%98%E7%AE%AD%E5%A4%B4.png',
  urlPre + '%E4%B8%80%E8%B7%AF%E7%9B%B8%E4%BC%B4bg.png',
];
export const advantages = [
  {
    title: '易用',
    desc: [
      '兼容利旧原有设备，保留原有使用习惯，降低学习成本',
      '支持全网4K高清视频效果，集各种视频功能于一体，满足各\n类业务场景个性化需求',
      '智能AI功能，支持智能人脸签到、本地电子铭牌、智能同声\n传译引擎、语音识别、实时双语字幕、自动整理会议纪要等',
    ],
    mDesc: [
      '兼容利旧原有设备，保留原有使用习惯，降低学习成\n本',
      '支持全网4K高清视频效果，集各种视频功能于一体，\n满足各类业务场景个性化需求',
      '智能AI功能，支持智能人脸签到、本地电子铭牌、智\n能同声传译引擎、语音识别、实时双语字幕、自动整\n理会议纪要等',
    ],
    icon: urlPre + '%E6%98%93%E7%94%A8.png',
  },
  {
    title: '易管',
    desc: [
      '统一的管理平台，自动化后台巡检，视频与数据可视化， 让\n管理尽在掌控',
      '一套工具，全流程管控，提升技术效能，减轻工作负担，降\n低运维成本',
      '分级授权管理，多角色、多层级、多架构灵活有序分工，让\n各版块管理有的放矢',
    ],
    mDesc: [
      '统一的管理平台，自动化后台巡检，视频与数据可视\n化， 让管理尽在掌控',
      '一套工具，全流程管控，提升技术效能，减轻工作负\n担，降低运维成本',
      '分级授权管理，多角色、多层级、多架构灵活有序分\n工，让各版块管理有的放矢',
    ],
    icon: urlPre + '%E6%98%93%E7%AE%A1.png',
  },
  {
    title: '易部署',
    desc: [
      '在任意服务器或云平台，实现快速部署，支持异地灾备和随\n时迁移',
      '平台无容量上限制约，支持万方级超大并发，弹性扩容、按\n需扩展',
      '支持加密互联网专有云、多网融合专有云、分区专有云多种\n部署方式，可适配不同需求场景',
    ],
    mDesc: [
      '在任意服务器或云平台，实现快速部署，支持异地灾\n备和随时迁移',
      '平台无容量上限制约，支持万方级超大并发，弹性扩\n容、按需扩展',
      '支持加密互联网专有云、多网融合专有云、分区专有\n云多种部署方式，可适配不同需求场景',
    ],
    icon: [
      {
        topic: '加密互联网专有云',
        desc: 'SaaS云视频服务，终端接入互联网即可使用，适用于中小型企业和基层政府单位',
        icon: urlPre + '%E6%98%93%E9%83%A8%E7%BD%B21-%E5%8A%A0%E5%AF%86.png',
      },
      {
        desc: '全平台入驻式部署，本地独立运行，适用于专线网络、大中型企业和部委厅局级政府单位',
        topic: '分区自治专有云',
        icon: urlPre + '%E6%98%93%E9%83%A8%E7%BD%B22-%E5%88%86%E5%8C%BA.png',
      },
      {
        desc: '内外混合云部署，兼具公有云和私有云优点，适用于各类政务及大中型企业用户',
        topic: '多网融合专有云',
        icon: urlPre + '%E6%98%93%E9%83%A8%E7%BD%B23-%E5%A4%9A%E7%BD%91.png',
      },
    ],
  },
];
export const clients = [
  {
    title: '河北省政务云视频平台',
    desc: '河北省政府携手小鱼易连和河北省联通，共同打造了“大平台、大系统、大数据”政务云视频平台，实现纵向省、市、县、乡镇、村五级单位全连接，横向突破全省各政府机构间信息壁垒。截止目前，已经覆盖近7000间会议室、5.5万村级终端，最大支持6.5万方并发，为河北省政府的现代化治理注入了强大势能，赋能数字政府建设。',
    link: LINK_PRE_PATH + '1041',
    logo: urlPre + '%E6%B2%B3%E5%8C%97%E7%9C%81%E6%94%BF%E5%8A%A1%E4%BA%91%E8%A7%86%E9%A2%91%E5%B9%B3%E5%8F%B0.png',
    grayLogo: urlPre + 'gray-logo/%E6%B2%B3%E5%8C%97%E7%9C%81%E6%94%BF%E5%8A%A1%E4%BA%91%E8%A7%86%E9%A2%91%E5%B9%B3%E5%8F%B0.png',
    img: urlPre + 'cases/%E6%B2%B3%E5%8C%97%E7%9C%81%E6%94%BF%E5%8A%A1%E4%BA%91%E8%A7%86%E9%A2%91%E5%B9%B3%E5%8F%B0.jpg',
  },
  {
    title: '贵州省应急管理厅',
    desc: '贵州省应急管理厅为提升突发事件的预防和处理能力，应用小鱼易连云视频，建立覆盖省委、省政府应急指挥中心、10个州市应急指挥中心、88个县级指挥中心和若干企业的省视频应急调度系统，打造了“纵向到底、横向到边”的应急管理体系，建立和健全全省突发事件处理机制，实现应急管理的规范化、精细化、智能化。',
    link: LINK_PRE_PATH + '1081',
    logo: urlPre + '%E8%B4%B5%E5%B7%9E%E5%BA%94%E6%80%A5.png',
    grayLogo: urlPre + 'gray-logo/%E8%B4%B5%E5%B7%9E%E5%BA%94%E6%80%A5.png',
    img: urlPre + 'cases/%E8%B4%B5%E5%B7%9E%E5%BA%94%E6%80%A52.jpg',
  },
  {
    title: '中国电子信息产业集团有限公司',
    desc: '中国电子信息产业集团有限公司是中央直接管理的国有重要骨干企业。作为网信产业国家队，中国电子积极创新探索和构建国产安全的数字底座，依托PKS生态体系，联合小鱼易连打造数字CEC视频能力平台，具备云协作、云视讯、云融合、云直播、云录播、云监控、云AI等服务功能，令全集团各公司、部门等18余万员工，实现了大范围、大规模的业务协同和更多场景的可视化应用。',
    link: LINK_PRE_PATH + '1075',
    logo: urlPre + '%E4%B8%AD%E5%9B%BD%E7%94%B5%E5%AD%90.png',
    grayLogo: urlPre + 'gray-logo/%E4%B8%AD%E5%9B%BD%E7%94%B5%E5%AD%90.png',
    img: urlPre + 'cases/%E4%B8%AD%E5%9B%BD%E7%94%B5%E5%AD%90.jpg',
  },
  {
    title: '中国建设银行',
    desc: '中国建设银行依托小鱼易连云视频，建设了建设银行龙视讯云平台，平台支持全行海量用户的移动视频会议需求，“超高清、低延时、高效便捷”的云视频，能大幅提升行内远程视频会议体验，同时，小鱼易连也满足董事会同声传译、个贷远程面签、信贷双录、远程审计、龙集采等各类创新场景应用，助力中国建设银行数字化转型。',
    link: LINK_PRE_PATH + '1098',
    logo: urlPre + '%E5%BB%BA%E8%AE%BE%E9%93%B6%E8%A1%8C.png',
    grayLogo: urlPre + 'gray-logo/%E5%BB%BA%E8%AE%BE%E9%93%B6%E8%A1%8C.png',
    img: urlPre + 'cases/%E5%BB%BA%E8%A1%8C.jpg',
  },
  {
    title: '巴蜀云校',
    desc: '巴蜀云校是应用5G和云视频等先进技术打造的巴蜀教育综合体，致力于通过小鱼易连云视频，联动各合作区域智慧教室，将巴蜀中学优质教育教学资源输送到友好学校，实现优质教育资源的共享共建。基于云视频打造的适合初级中学、高完中、高级中学各学龄阶段的线上“面对面”教育教学系统，为推进教育公平铺平道路。',
    link: LINK_PRE_PATH + '5befeb',
    logo: urlPre + '%E5%B7%B4%E8%9C%80%E4%BA%91%E6%A0%A1.png',
    grayLogo: urlPre + 'gray-logo/%E5%B7%B4%E8%9C%80%E4%BA%91%E6%A0%A1.png',
    img: urlPre + 'cases/%E5%B7%B4%E8%9C%80%E4%BA%91%E6%A0%A1-%E6%B1%89%E8%AF%AD%E6%A1%A5.jpg',
  },
  {
    title: '湖南省卫生健康委员会',
    desc: '湖南省卫健委携手小鱼易连，搭建覆盖全省的云视频远程会诊平台，建设了连接湖南全省20个贫困县的35家县级医院远程综合诊室、350个县级医院远程单科诊室和246个乡镇卫生院远程诊室。湖南省卫健委基于小鱼易连云视频“超高清、低延时、强互动”的高品质解决方案，组织张家界、常德、长沙、益阳、湘潭等多个地市的定点医院的医疗专家远程会诊患者，为疫情的远程诊疗、防疫防控建立“云防线”。',
    link: LINK_PRE_PATH + '1036',
    logo: urlPre + '%E6%B9%96%E5%8D%97%E7%9C%81%E5%8D%AB%E7%94%9F%E5%81%A5%E5%BA%B7%E5%A7%94%E5%91%98%E4%BC%9A.png',
    grayLogo: urlPre + 'gray-logo/%E6%B9%96%E5%8D%97%E7%9C%81%E5%8D%AB%E7%94%9F%E5%81%A5%E5%BA%B7%E5%A7%94%E5%91%98%E4%BC%9A.png',
    img: urlPre + 'cases/%E6%B9%96%E5%8D%97%E5%8D%AB%E5%81%A5%E5%A7%94-%E5%85%A8%E7%9C%81%E5%88%86%E7%BA%A7%E8%AF%8A%E7%96%974.jpg',
  },
];
